module.exports = __webpack_public_path__ + "img/96.270aa65e.jpg";